import React from 'react';
import { withRouter } from 'react-router';
// import { setL } from '../../../../../util/lib';
import HybridLink from '../../../hybrid/footer/HybridLink';
import HeaderSubMenu from './HeaderSubMenu';

import './scss/HeaderMenu.scss';

const HeaderMenu = (props) => {
	const { data: wData = {}, primaryMenuCssClass = '' } = props,
		{ 
			data = {},
			// meta = {},
			// activePage = '/'
		} = wData,
		{ cards = [] } = data,
		cardsArray = Array.isArray(cards) ? cards : [],
		location = props.location || {}; //TEUX DUEX

	let pathName = location.pathname || '/';

	if (pathName === '/' || pathName === '') { //TEUX DUEX
		pathName = '/home';
	}

	return (
		<ul className={`navbar-nav mr-auto all-links main-nav ${primaryMenuCssClass}`}>
			{cardsArray.map((card, index) => {
				const { data: cardData = {}, type: cardType = '' } = card,
					{ action = {} } = cardData,
					{ primary = {} } = action,
					{ path = '/' } = primary,
					//added exception for external links
					isActive = (pathName.indexOf(path) >= 0 && path !== ''),
					activeClassName = isActive ? 'active' : '';
					
				return (
					<li key={`header-menu-${index}`} className="nav-item">
						{cardType === 'HybridLink' && <HybridLink
							data={card}
							labelAdditionalClass={`nav-link true-link ${activeClassName}`}
						/>}

						{(cardType === 'SubMenu' || cardType === 'DropDown') && <HeaderSubMenu
							data={card} id={`header-menu-${index}`}
							key={`header-menu-${index}`}
						/>}
					</li>
				);
			})}
		</ul>
	);
}

export default withRouter(HeaderMenu);
